import { h } from "preact";

import style from "./style";
import SubHeading from "../subheading";

const capitalize = (text) => {
  return text[0].toUpperCase() + text.slice(1);
}

const DetailSection = ({id, title, children}) => (
  <section id={id} class={style['detail-section']}>
    <SubHeading text={capitalize(title)} />
    <article>
      {children}
    </article>
  </section>
)

export default DetailSection;
